const GraphQLQuery = require('app/graphql/Query');
const GraphQLMutation = require('app/graphql/Mutation');

const RestaurantSelect = require('app/ui/form/RestaurantSelect');

class Picker {
    defaultOptions() {
        return {
            '$container': $('<div/>'),
            'restaurant': null,

            'success': function(data){},
        };
    }

    constructor(options) {
        this.settings = $.extend(this.defaultOptions(), options);

        this.onSearchSubmit = this.onSearchSubmit.bind(this);
        this.onSubmitSelection = this.onSubmitSelection.bind(this);

        this.$container = this.settings.$container;
        this.restaurant = this.settings.restaurant;

        this.selection = null;

        this.initialize();
    }

    initialize() {
        var self = this;
        this.build();
    }


    build(){


        this.$formSearch = $('<form/>')
        .addClass('form form-search-user white-box')
        .on("submit",this.onSearchSubmit);


        this.$restaurantSelect = $('<select/>')
        .addClass('form-control select2')
        .attr('name','restaurant');


        this.restaurantSelect = new RestaurantSelect({
            'labelEmpty': 'Filtrer par restaurant',
            '$select': this.$restaurantSelect,
            'except': this.restaurant.id,
            'onChange': this.onSearchSubmit,
            'filters': {
                'particulier': false, 
            },
        })


        this.$keywordInput = $('<input/>')
        .addClass('form-control')
        .attr('name','keyword')
        .attr('placeholder',"Mot clés")
        .on('change',this.onSearchSubmit);

        this.$searchSubmit = $('<button/>')
        .attr('type','button')
        .addClass('btn btn-primary btn-search')
        .append(
            $('<i/>')
            .addClass("fas fa-search")
        )
        .on('change',this.onSearchSubmit);

        this.$formSearch
        .append(
            $('<h3/>')
            .append("Recherche d'un utilisateur")
        )
        .append(
            $('<div/>')
            .addClass('row')
            .append(
                $('<div/>')
                .addClass('col-4 p-1')
                .append(this.$restaurantSelect)
            )
            .append(
                $('<div/>')
                .addClass('col-7 p-1')
                .append(this.$keywordInput)
            )
            .append(
                $('<div/>')
                .addClass('col-1 p-1')
                .append(this.$searchSubmit)
            )
        );


        this.$resultContainer = $('<div/>')
        .addClass('user-picker-result-container');


        this.$btnSubmit = $('<button/>')
        .attr('type','button')
        .addClass('btn btn-success')
        .append("Ajouter cet utilisateur au restaurant")
        .on("click",this.onSubmitSelection)
        .hide();

        this.$actionContainer = $('<div/>')
        .addClass('user-picker-action-container')
        .addClass('d-flex justify-content-center')
        .append(this.$btnSubmit);

        this.$container
        .append(this.$formSearch)
        .append(this.$resultContainer)
        .append(this.$actionContainer)
    }

    onSearchSubmit(event){
        var self = this;
        event.preventDefault();
        event.stopPropagation();

        this.$btnSubmit.hide();
        this.$resultContainer
        .html('')
        .append(
            $('<div/>')
            .addClass('loader d-flex justify-content-center')
            .append(
                $('<i/>')
                .addClass('fas fa-spin fa-spinner fa-2x')
            )
        );

        let filters = {
            'type': 4,
            'notRestaurant': this.restaurant.id,
        };

        if(this.$restaurantSelect.val()){
            filters['restaurant'] = parseInt(this.$restaurantSelect.val());
        }

        if(this.$keywordInput.val()){
            filters['search'] = this.$keywordInput.val();
        }

        let parameters = {
            'first': 10,//to be sure to have all
            'filter': filters,
            'orderBy': 'lastName',
            'dir': 'ASC',
        };

        let fields = [
            'id',
            'firstName',
            'lastName',
            'login',
            'email',
            'restaurantAssociations { restaurant { id name}}'
        ];

        let query = new GraphQLQuery({
            //parameters
            'queryType': 'users',
            'parameters': parameters,
            'fields': fields,
            'hasEdges': true,
            'addPageInfo': false,
            'addTotalCount': false,
            //callbacks
            'before': function(){
            },
            'success': function(data){
                let items = data.edges;
                self.showSearchResults(items);
            },
            'error': function(message, data){
                console.error(message,data);
                window.notify(message,"danger");
            },
            'after': function(){
            }
        });

        query.execute();
    }

    showSearchResults(items){
        var self = this;
        this.$resultContainer
        .html('');

        if(!items || items.length <= 0){

            this.$resultContainer
            .append(
                $('<div/>')
                .addClass('alert alert-warning')
                .append('Aucun utilisateur trouvé')
            )
        }else{ 

            let $list = $('<ul/>')
            .addClass('user-picker-result-list')
            .addClass('list-unstyled');


            for(var i in items){
                let item = items[i];
                console.log("item ",item);

                let user = item.node;
                let restaurantAssociations = item.node.restaurantAssociations;

                let id = user.id;

                let $user = $('<ul/>')
                .addClass('list-unstyled')
                .append(
                    $('<li/>')
                    .append(
                        $('<strong/>')
                        .addClass('me-1')
                        .append('Nom')
                    )
                    .append(user.lastName + ' ' + user.firstName)
                )
                .append(
                    $('<li/>')
                    .append(
                        $('<strong/>')
                        .addClass('me-1')
                        .append('Identifiant')
                    )
                    .append(user.login)
                )
                .append(
                    $('<li/>')
                    .append(
                        $('<strong/>')
                        .addClass('me-1')
                        .append('E-mail')
                    )
                    .append(user.email)
                );


                let $restaurants = $('<ul/>')
                .addClass('list-unstyled');

                for(var r in restaurantAssociations){

                    let restaurantAssociation = restaurantAssociations[r];
                    let restaurant = restaurantAssociation.restaurant;
                    console.log("restaurantAssociations ",restaurantAssociation);

                    $restaurants.append(
                        $('<li/>')
                        .append(restaurant.name)
                    )
                }

                let $content = $('<div/>')
                .addClass('row')
                .append(
                    $('<div/>')
                    .addClass('col-8')
                    .append($user)
                )
                .append(
                    $('<div/>')
                    .addClass('col-4')
                    .append($restaurants)
                )


                let $line = $('<li/>')
                .addClass('user-picker-result-item')
                .attr('data-id',id)
                .append($content)
                .on('click',function(event){
                    event.preventDefault();
                    event.stopPropagation();
                    self.onPick(user);
                });

                $list.append($line);
            }

            this.$resultContainer
            .append(
                $list
            )
        }
    }

    onPick(user){
        this.selection = user;
        $('.user-picker-result-item').removeClass('active');
        $('.user-picker-result-item[data-id="'+user.id+'"]').addClass('active');

        this.$btnSubmit.show();
    }

    onSubmitSelection(event){
        var self = this;

        event.preventDefault();
        event.stopPropagation();


        let fields = [
            'success',
            'message',
            'errors { key, value }',
        ];
        let variables = {
            'restaurant': {
                'value': this.restaurant.id,
                'type': 'Int!'
            },
            'user': {
                'value': this.selection.id,
                'type': 'Int!'
            },
            'mode':{
                'value': 'newAssociation',
                'type': 'String'
            }
        };
        let mutation = new GraphQLMutation({
            //Mutation parameters
            'mutationType': "SubmitRestaurantContact",
            'fields': fields,
            'variables': variables,//format: {NAME:{'type':TYPE, 'value': VALUE}}

            //callbacks
            'before': function(){
            },
            'success': function(data){
                window.notify(data.message,'success');
                self.onSubmitSucceed(data);
            },
            'error': function(message, xhr){
                window.notify(message,'error');
            },
            'after': function(){
                //do nothing
            }
        });
        mutation.execute();
    }

    onSubmitSucceed(data){
        this.settings.success(data);
    }


    getContent(){
        return this.$container;
    }

}

module.exports = Picker;

